"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useIsMobile = void 0;
var react_1 = require("react");
var MOBILE_MAX_WIDTH_PX = 768; // MD breakpoint
function useIsMobile() {
    var _a = (0, react_1.useState)(function () {
        if (typeof window !== 'undefined') {
            return window.innerWidth;
        }
        return undefined;
    }), width = _a[0], setWidth = _a[1];
    (0, react_1.useEffect)(function () {
        var handleResize = function () {
            setWidth(window.innerWidth);
        };
        handleResize();
        window.addEventListener('resize', handleResize);
        return function () {
            window.removeEventListener('resize', handleResize);
        };
    }, []);
    // If width is undefined, this was server side rendered and we default to desktop view.
    return width !== undefined && width <= MOBILE_MAX_WIDTH_PX;
}
exports.useIsMobile = useIsMobile;
